class DragTrack extends HTMLElement {
  constructor() {
    super()

    // 拖拽状态
    this.dragging = false

    // 配置参数
    this.min = Number(this.getAttribute('min')) || 1
    this.max = Number(this.getAttribute('max')) || 100
    this.step = Number(this.getAttribute('step')) || 1
    this.value = this.hasAttribute('value') ? Number(this.getAttribute('value')) : this.min

    // labels
    this._labels = []

    // 缓存最后触发值
    this._lastEmittedValue = null

    this._onResize = this._onResize.bind(this)

    this._render()
    this._bind()
  }

  static get observedAttributes() {
    return ['min', 'max', 'step', 'value']
  }

  connectedCallback() {
    this._updateUI()
    this.resizeObserver = new ResizeObserver(this._onResize)
    this.resizeObserver.observe(this.container)
  }

  disconnectedCallback() {
    this.resizeObserver?.disconnect()
  }

  attributeChangedCallback(name, oldVal, newVal) {
    if (oldVal === newVal) return
    this[name] = Number(newVal)
    this._updateUI()
  }

  /* ---------- labels API ---------- */
  setLabels(labels) {
    if (!Array.isArray(labels)) throw new Error('labels must be an array')
    this._labels = labels
    this._updateUI()
  }

  set labels(val) { this.setLabels(val) }
  get labels() { return this._labels }

  /* ---------- 渲染 ---------- */
  _render() {
    this.innerHTML = `
      <div class="drag-track">
        <div class="track"></div>
        <div class="ball"></div>
      </div>
    `
    this.container = this.querySelector('.drag-track')
    this.ball = this.querySelector('.ball')
  }

  /* ---------- 事件绑定 ---------- */
  _bind() {
    this.ball.addEventListener('pointerdown', e => {
      this.dragging = true
      this.ball.setPointerCapture(e.pointerId)
      this._lastEmittedValue = null // 开始拖拽重置
      this._emit('drag-start')
    })

    document.addEventListener('pointermove', e => {
      if (!this.dragging) return
      this._onMove(e)
    })

    document.addEventListener('pointerup', () => {
      if (!this.dragging) return
      this.dragging = false
      // 拖拽结束触发最终 change
      this._emit('drag-end')
      this._emit('change')
      this._lastEmittedValue = null
    })
  }

  /* ---------- 拖拽逻辑 ---------- */
  _onMove(e) {
    const rect = this.container.getBoundingClientRect()
    let x = e.clientX - rect.left
    x = Math.max(0, Math.min(x, rect.width))

    const percent = x / rect.width
    const rawValue = this.min + percent * (this.max - this.min)
    const steppedValue = Math.round((rawValue - this.min) / this.step) * this.step + this.min
    const newValue = Math.min(this.max, Math.max(this.min, steppedValue))

    // 如果值没变，或者拖到头不触发
    if (newValue === this.value) return

    this.value = newValue
    this.setAttribute('value', this.value)
    this._updateUI()

    this._emit('dragging')

    // 拖拽中 change 每次只触发一次
    if (this._lastEmittedValue !== this.value) {
      this._emit('change')
      this._lastEmittedValue = this.value
    }
  }

  /* ---------- 显示 ---------- */
  _getLabel() {
    if (!this._labels.length) return String(this.value)
    const ratio = (this.value - this.min) / (this.max - this.min)
    const index = Math.round(ratio * (this._labels.length - 1))
    return this._labels[index]
  }

  _updateUI() {
    if (!this.ball) return
    const percent = (this.value - this.min) / (this.max - this.min)
    this.ball.style.left = `${percent * 100}%`
    this.ball.textContent = this._getLabel()
  }

  _onResize() {
    this._updateUI()
  }

  /* ---------- 事件派发 ---------- */
  _emit(type) {
    this.dispatchEvent(new CustomEvent(type, {
      detail: { value: this.value, label: this._getLabel() },
      bubbles: true
    }))
  }
}

customElements.define('drag-track', DragTrack)
